export const request = async (method, path, { params, query, headers }) => {
    const response = await fetch(path, {
        method,
        headers,
        body: JSON.stringify(params),
    })

    const data = await maybeGetJson(response)

    if (response.ok) {
        return data
    } else {
        throw {
            status: response.status,
            response: data,
        }
    }
}

const maybeGetJson = async (response) => {
    const text = await response.text()

    try {
        return JSON.parse(text)
    } catch (e) {
        return null
    }
}

